import React, { SVGProps } from 'react';

interface TransferIconProps extends SVGProps<SVGSVGElement> {
  fillColor?: string;
  arrowColor?: string;
  circleColor?: string;
}

const TransferIcon = ({
  fillColor = 'transparent',
  arrowColor = '#fff',
  circleColor = '#2894F9',
  ...props
}: TransferIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    data-palette="TransferIcon">
    <rect
      width={10.714}
      height={10.714}
      x={0.643}
      y={0.643}
      fill={fillColor}
      stroke={circleColor}
      strokeWidth={1.286}
      rx={5.357}
    />
    <path
      stroke={arrowColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.686}
      d="M6.92 8.571V3.43l1.652 1.767M5.082 3.43V8.57L3.43 6.804"
    />
  </svg>
);

export default TransferIcon;
